// extracted by mini-css-extract-plugin
export default {"criteriaForm":"CriteriaForm_criteriaForm__zU1Gf","ant-select":"CriteriaForm_ant-select__FZ9qZ"};